import styled from "styled-components/macro";

export const Content = styled.div(({ theme: { spacing } }) => ({
  "> *": {
    marginTop: spacing.stack.sm,
    marginBottom: spacing.stack.sm,

    ":last-child": {
      marginBottom: 0,
    },
  },
}));

export const Section = styled.div(({ theme: { spacing } }) => ({
  "> *": {
    marginBottom: spacing.stack["4xs"],

    ":last-child": {
      marginBottom: 0,
    },
  },
}));
